export default __webpack_public_path__ + "816024951b408a7359a47c0c09b06c8f.jpg";